import axios from "axios";

const API_BASE_URL =
  import.meta.env.VITE_API_BASE ||
  "http://localhost:9398/api/v1";

console.log("RAW VITE API:", import.meta.env.VITE_API_BASE);
// console.log("Base URL being used:", API_BASE);

export const http = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);